(() => {
 'use strict';
 if (window.__vaylorProductStarted) return;
 window.__vaylorProductStarted = true;
 const ready = root => {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  let request, opener, busy=false;
  const status=root.querySelector('[data-product-status]');
  const track=root.querySelector('[data-image-track]');
  const slides=()=>Array.from(track?.children||[]);
  let imageIndex=0;
  function showImage(index,smooth=true){
   if(!track||!slides().length)return;
   imageIndex=Math.max(0,Math.min(slides().length-1,index));
   track.scrollTo({left:imageIndex*track.clientWidth,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
   root.querySelectorAll('[data-image-index]').forEach(button=>{if(Number(button.dataset.imageIndex)===imageIndex)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
   const counter=root.querySelector('[data-gallery-count]');
   if(counter)counter.textContent=(imageIndex+1)+' / '+slides().length;
  }
  function variantImage(state){
   const index=slides().findIndex(slide=>slide.dataset.imageId===state.dataset.imageId);
   if(index>=0)showImage(index,false);
  }
  let raf;
  track?.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{const index=Math.round(track.scrollLeft/track.clientWidth);imageIndex=index;root.querySelectorAll('[data-image-index]').forEach(button=>{if(Number(button.dataset.imageIndex)===index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});const counter=root.querySelector('[data-gallery-count]');if(counter)counter.textContent=(index+1)+' / '+slides().length;});},{passive:true});
  track?.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showImage(imageIndex+(event.key==='ArrowRight'?1:-1));}});
  const dialog=root.querySelector('.pdp-size-dialog');
  dialog?.addEventListener('close',()=>opener?.focus());
  root.addEventListener('click',event=>{
   const thumb=event.target.closest('[data-image-index]');
   if(thumb)showImage(Number(thumb.dataset.imageIndex));
   const step=event.target.closest('[data-gallery-step]');
   if(step)showImage((imageIndex+Number(step.dataset.galleryStep)+slides().length)%slides().length);
   const size=event.target.closest('[data-size-guide]');
   if(size&&dialog){opener=size;dialog.showModal();}
   if(event.target.closest('[data-close-size]'))dialog?.close();
  });
  dialog?.addEventListener('click',event=>{
   if(event.target!==dialog)return;
   const r=dialog.getBoundingClientRect();
   if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
  });
  function sync(state){
   const groups=Array.from(state.querySelectorAll('[data-option-position]'));
   let complete=true;
   for(const group of groups){
    const selected=group.querySelector('input:checked');
    if(!selected)complete=false;
    group.querySelector('[data-option-label]').textContent=selected?.value||'—';
   }
   const form=state.querySelector('[data-product-form]');
   const id=form.querySelector('[data-variant-id-input]');
   const valid=complete && Boolean(state.dataset.variantId);
   id.value=valid?state.dataset.variantId:'';
   const button=form.querySelector('.pdp-add');
   button.disabled=!valid || state.dataset.available!=='true' || busy;
   const availability=state.querySelector('[data-availability]');
   if(!complete)availability.textContent='Choisissez vos options';
   else if(!state.dataset.variantId)availability.textContent='Cette combinaison est indisponible';
   else availability.textContent=state.dataset.available==='true'?'En stock':'Épuisé';
  }
  sync(root.querySelector('[data-product-state]'));
  variantImage(root.querySelector('[data-product-state]'));
  root.addEventListener('change',async event=>{
   const input=event.target.closest('input[data-option-id]');
   if(!input)return;
   request?.abort();
   request=new AbortController();
   const state=root.querySelector('[data-product-state]');
   const choices=new Map(Array.from(state.querySelectorAll('[data-option-position]')).map(group=>[group.dataset.optionPosition,group.querySelector('input:checked')?.dataset.optionId||null]));
   const ids=Array.from(state.querySelectorAll('[data-option-position]')).map(group=>group.querySelector('input:checked')?.dataset.optionId||group.querySelector('input:not(:disabled)')?.dataset.optionId||group.querySelector('input')?.dataset.optionId);
   state.querySelector('.pdp-add').disabled=true;
   state.querySelector('[data-variant-id-input]').value='';
   state.setAttribute('aria-busy','true');
   if(status)status.textContent='';
   try{
    const url=new URL(input.dataset.productUrl||root.dataset.productUrl,location.origin);
    url.searchParams.delete('variant');
    url.searchParams.set('option_values',ids.join(','));
    url.searchParams.set('section_id',root.dataset.sectionId);
    const response=await fetch(url,{credentials:'same-origin',signal:request.signal});
    if(!response.ok)throw new Error('Impossible de vérifier cette variante. Réessayez.');
    const html=new DOMParser().parseFromString(await response.text(),'text/html');
    const next=html.querySelector('[data-product-state]');
    if(!next)throw new Error('Options indisponibles. Actualisez la page.');
    for(const group of next.querySelectorAll('[data-option-position]')){
     for(const radio of group.querySelectorAll('input'))radio.checked=radio.dataset.optionId===choices.get(group.dataset.optionPosition)&&!radio.disabled;
    }
    const focusId=input.dataset.optionId;
    const oldUrl=root.dataset.productUrl;
    const incoming=html.querySelector('[data-product-page]');
    if(incoming&&incoming.dataset.productUrl!==oldUrl){
     location.assign(url.pathname+'?option_values='+ids.join(','));
     return;
    }
    state.replaceWith(next);
    sync(next);
    variantImage(next);
    next.querySelector('input[data-option-id="'+CSS.escape(focusId)+'"]')?.focus({preventScroll:true});
    const complete=Array.from(next.querySelectorAll('[data-option-position]')).every(group=>group.querySelector('input:checked'));
    if(complete&&next.dataset.variantId){
     const current=new URL(location.href);
     current.searchParams.delete('option_values');
     current.searchParams.set('variant',next.dataset.variantId);
     history.replaceState({},'',current);
    }
   }catch(error){
    if(error.name==='AbortError')return;
    if(status)status.textContent=error.message;
    state.querySelector('[data-variant-id-input]').value='';
    state.querySelector('.pdp-add').disabled=true;
   state.querySelector('[data-variant-id-input]').value='';
   }finally{state.removeAttribute('aria-busy');}
  });
  root.addEventListener('submit',async event=>{
   const form=event.target.closest('[data-product-form]');
   if(!form)return;
   event.preventDefault();
   if(busy||!form.reportValidity())return;
   const data=new FormData(form);
   const id=String(data.get('id')||'');
   const quantity=Number(data.get('quantity'));
   if(!/^\d+$/.test(id)||!Number.isSafeInteger(quantity)||quantity<1)return;
   busy=true;
   const button=form.querySelector('.pdp-add');
   button.disabled=true;
   form.setAttribute('aria-busy','true');
   status.textContent='Ajout en cours…';
   try{
    const item={id,quantity};
    if(data.get('selling_plan'))item.selling_plan=String(data.get('selling_plan'));
    const response=await fetch(root.dataset.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||result.message||'Impossible d’ajouter cette pièce.');
    status.textContent='Pièce ajoutée au panier.';
    const link=document.createElement('a');link.href=root.dataset.cartUrl;link.textContent='Voir le panier';status.append(link);
    try{
     const response=await fetch(root.dataset.cartUrl+'.js',{credentials:'same-origin'});
     if(response.ok){
      const cart=await response.json();
      document.querySelectorAll('.cart-link').forEach(link=>{let badge=link.querySelector('.cart-count');if(cart.item_count>0){if(!badge){badge=document.createElement('span');badge.className='cart-count';link.append(badge);}badge.textContent=cart.item_count;}else badge?.remove();link.setAttribute('aria-label','Panier ('+cart.item_count+')');});
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
     }
    }catch{}
   }catch(error){status.textContent=error.message;}
   finally{busy=false;form.removeAttribute('aria-busy');sync(root.querySelector('[data-product-state]'));}
  });
 };
 function mount(){
  document.querySelectorAll('[data-product-page]').forEach(ready);
  document.querySelectorAll('[data-product-recommendations]').forEach(root=>{
   if(root.dataset.ready||root.querySelector('h2'))return;
   root.dataset.ready='true';
   const load=async()=>{try{const response=await fetch(root.dataset.url,{credentials:'same-origin'});if(!response.ok)return;const html=new DOMParser().parseFromString(await response.text(),'text/html');const next=html.querySelector('[data-product-recommendations]');if(next?.querySelector('h2'))root.replaceChildren(...next.childNodes);}catch{}};
   if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:'200px'});observer.observe(root);}else load();
  });
 }
 mount();
 document.addEventListener('shopify:section:load',mount);
})();